<template xmlns:v-popover="">
    <el-container>
      <!-- The popovers that you can find here are all for showing the user some useful hints -->

      <div id="selection">
        <!-- DateTime picker -->
        <el-row>

          <div class="block">
            <span class="title">Select Date: </span>
            <el-date-picker
              v-model="valueDatePicker"
              type="daterange"
              value-format="yyyy_MM_dd_HH_mm_ss"
              :picker-options="pickerOptions"
              range-separator="To"
              start-placeholder="Start date"
              end-placeholder="End date"
              align="right"
              v-popover:popOverDateTime>
            </el-date-picker>
          </div>
        </el-row>

        <el-row v-show="valueDatePicker !== ''">
          <!-- Multiple selections (parameter, operator and input) -->
          <div v-for="row in rowNumber">
            <app-queryselection :listParams="listParams"
                                :rowNumber.sync="rowNumber"
                                :queryParameters="queryParameters"></app-queryselection>
          </div>
        </el-row>

        <el-row>
          <!-- Output parameters (FPGA Version, Temperature...) -->
          <el-col :span="8">

            <el-tooltip class="item" effect="dark" content='Select one or more parameters that you want to see in the graph' placement="top-start">
              <el-select v-show="queryParameters.length !== 0" multiple v-model="outputParams" filterable placeholder="Output" collapse-tags auto-complete="true" v-popover:popOverOutputParam>
                <el-option
                  v-for="element in listParams"
                  :key="element.code"
                  :label="element.name"
                  :value="element.code">
                </el-option>
              </el-select>
            </el-tooltip>
          </el-col>

          <!-- SEND button -->
          <el-button v-show="outputParams!='' && valueDatePicker!='' && rowNumber>1" v-on:click="sendRequest()">SEND</el-button>
        </el-row>
      </div>
      <highcharts v-loading="!dataReady" :options="chartOptions" ref="highcharts"></highcharts>
  </el-container>
</template>

<script>
  import Element from 'element-ui';
  import axios from 'axios';
  import HighCharts from 'vue-highcharts'

  export default {
    name: 'Query',
    props: ['listParams'],
    data () {
      return {
        /* Chart */
        chartData: [],
        chartOptions : {
          chart:{
            type: 'line',
            zoomType: 'x'
          },
          title: {
            text: 'Parameters over time'
          },
          xAxis: {
            title: {
              text: 'Time'
            },
            minTickInterval: 500
          },
          yAxis: {
            title: {
              text: 'Value'
            },
            plotLines: [{
              value: 0,
              width: 1,
              color: "#ccc",
            }],
          },
          legend: {
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle'
          },
          credits: {
            enabled : false,
          },
          series: [],
        },

        /* Query generation */
        queryresult : [],
        queryParameters: [], /* This array exists to take in all the querySelection component values */
        selectedLogicalOperators: [], /* Logical operators selected by the user */
        resultLenght: 0,
        dataReady : true,

        /* Query visualization */
        rowNumber : 1,
        outputParams: [], /* Filter for the final result (so you can see only a specific parameter) */
        listParams: [],  /* Parameter list taken from the db*/
        listDates: [], /* List of dates taken from the db where the device worked */

        /* Date picker*/
        valueDatePicker: '',
        pickerOptions: {
          firstDayOfWeek: 1,
          disabledDate: this.disableDates,
          shortcuts: [{
            text: 'Last day',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: 'Last 7 days',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },{
            text: 'Last month',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: 'Last 3 months',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
        }, /* These are the displayed info to the left that let you choose a predefined range */
      };
    },

    methods: {
      disableDates: function (date) {
        let app = this;
        let year;
        let month;
        let day;
        let workingDate;
        let returnValue = true;

        app.listDates.forEach(function (element) {
          year = element.split("_")[0]
          month = element.split("_")[1]
          day = element.split("_")[2]
          workingDate = new Date(year, month-1, day, 0, 0, 0)
          if(date.getTime() === workingDate.getTime())
            returnValue=false;
        })

        return returnValue;
      },
      sendRequest: function () {
        let app = this;
        let startDate = app.valueDatePicker[0].split("_");
        let finishDate = app.valueDatePicker[1].split("_")

        /* This is the generated query with all the important parameters */
        let query = `${app.queryParameters.toString().replace(/,/g,'').slice(0, -4)}`;
        app.dataReady = false;
        /* Main Ajax call (queryParameters are slices to remove the last logical operator to make the query work without throwing an exception) */
        axios.post(`https://iiot.dave.eu/api/advancedQuery`, {
          device: app.$attrs.deviceId,
          startPoint: app.valueDatePicker[0],
          finishPoint: app.valueDatePicker[1],
          query: query
        }).then(function (response) {
            app.queryresult = []; // Empty the variable

            /* Iterate in the result set to get all elements */
            response.data.forEach(function (element) {
              app.queryresult.push(element)
            });

            let dataArray = []; // dataArray to mount a series in the chart
            let labelArray = [{categories:''}]; // labelArray to add the xAxis labels (dates)
            let tmpLabelArray = []  // temporary array to store dates
            let chart = app.$refs.highcharts.chart;

            let seriesLength = chart.series.length;
            for(let i = seriesLength -1; i > -1; i--) {
              chart.series[i].remove();
            }

            /* For each parameter selected in output */
            app.outputParams.forEach(function (param) {
              let temp = param;
              /* This forEach gets the long name of the parameter from the listParams */
              app.listParams.forEach(function (name) {
                if(name.code === param)
                  app.chartData["name"] = name.name;
              })

              // This is a workaround for the fact that the SQL database doesn't allow UpperCases in fields to distinguish them so I just added a 1
              if (temp === param.toUpperCase()) {
                temp += '1';
              }

              const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
              /* For each result */
              app.queryresult.forEach(function (element) {
                let date = new Date(element['utctime']);

                if(typeof element[temp] === "undefined")
                  dataArray.push(null);
                else
                  dataArray.push(element[temp]);

                tmpLabelArray.push(`${date.getDate()} ${monthNames[date.getUTCMonth()]} ${date.getFullYear()} - ${date.getHours()}:${date.getMinutes()}:${date.getSeconds()}`)
              })

              app.chartData["data"] = dataArray;
              chart.addSeries(app.chartData);
              dataArray = [];
              app.chartData = [];
            })

            /* Label update */
            labelArray[0].categories = tmpLabelArray;

            /* Chart update */
            chart.xAxis[0].update(labelArray[0])

            /* SUCCESS message */
            app.$message({
              showClose: true,
              message: "SUCCESS: Got response from db",
              type: 'success'
            });
            app.dataReady = true;
          }).catch(function (error){  // Catch errors
            /* ERROR message */
            if(error.hasOwnProperty("response")) {
              app.$message({
                showClose: true,
                message: "ERROR " + error.response.status + " - " + error.response.statusText,
                type: 'error'
              });
            }else {
              console.error(error + "  -  " + error)
              app.dataReady = true;
            }
        })
      },
    },
    /* These instructions get executed when the component is loaded */
    created: function () {
      let app = this;

      /* Ajax call to get all dates of the current device from database*/
      axios.get(`https://iiot.dave.eu/api/devices`)
        .then(function (response) {

          response.data.forEach(function (element) {
            if(element.deviceId === app.$attrs.deviceId)
              app.listDates = element.days;
          })
        }).catch(function (error){
        console.error(`Download Days ERROR: ${error.response.data.message}`);
      })
    }
  }
</script>

<style  scoped>
  #selection{
    border:1px solid #ccc;
    border-radius: 12px;
    text-align: center;
  }
  .el-row{
    padding: 2%;
  }
  .el-container{
    display: block!important;
  }
  .el-select, .el-input{
    width: max-content;
    display: inline-block;
  }
  .result{
    margin-bottom: 2%;
    min-height: 200px;
    text-align: center;
    border: 1px solid #ccc;
    border-radius: 10px;
    box-shadow: rgba(0, 0, 0, 0.12) 0px 1px 6px, rgba(0, 0, 0, 0.12) 0px 1px 4px;
  }

  #addRow{
    position: absolute;
    right: 5%;
  }
</style>



// WEBPACK FOOTER //
// src/components/Query.vue